module.exports = __webpack_public_path__ + "img/Slideshows-espace-client-diff-selective-auto.61811051.png";